$(document).ready(function(){
    $('.product-hero-image').slick({
        dots: false,
        arrows: true,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev"><svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" width="20" height="20" viewBox="0 0 8 14"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" width="20" height="20" viewBox="0 0 8 14"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"/></svg></button>'
    });
    $('.ui-accordion-header').on('click',function(){
        $(this).next().slideToggle();
    })
    $('.load-more-button').on('click',function(){
        $('.column-wrapper.product-list').attr('style','');
        $('.load-more-button-wrapper').attr('style','display: none;');
    });
    var app = new App(window.product.handle);
    app.init();
})

class App{
    constructor(handle){
        this.handle = handle
        this.variant_id = null;
        this.variant_sku = null;
        this.product_price = 0;
        this.options_price = 0;
        this.total_price = 0;
        this.slideIndex = 1;
        this.zoom_slides;
        this.nav_zoom_slides;
    }
    init(){
        var self = this;
        this.addEventSelectItem();
        this.addEventSelectOption();
        this.addEventSelectProperty();
        this.addToCart();
        this.addEventOpenModal();
        this.addEventCloseModal();
        $('.view-selection-mobile a').on('click',function(e){
            e.preventDefault();
            $('.cart-sticky').addClass('is-open');
            $('body').css({
                overflow: 'hidden',
                height: '100%',
                visibility: 'visible',
                display: 'block',
                inset: '0px auto auto 0px',
                margin: '0px',
                opacity: '1 !important'
            });
            $('html').css({
                overflow: 'hidden',
                margin: '0px !important'
            });
            $(this).hide();
        })
        $('.close-cart-sticky').on('click',function(e){
            e.preventDefault();
            $('.cart-sticky').removeClass('is-open');
            $('body').removeAttr('style');
            $('html').removeAttr('style');
            $('.view-selection-mobile a').show();
        })
        $('.cart-sticky-overlay').on('click',function(e){
            e.preventDefault();
            $('.cart-sticky').removeClass('is-open');
            $('body').removeAttr('style');
            $('html').removeAttr('style');
            $('.view-selection-mobile a').show();
        });
        if ($(window).scrollTop() > $('#visual-selector-tool').offset().top) {
            $('.view-selection-mobile').removeClass('hide');
        } else {
            $('.view-selection-mobile').addClass('hide');
        }
        $(window).on('resize scroll', function() {
            if ($(window).scrollTop() > $('#visual-selector-tool').offset().top) {
                $('.view-selection-mobile').removeClass('hide');
            } else {
                $('.view-selection-mobile').addClass('hide');
            }
        });
        this.zoom_slides = new Swiper('.slider-for', {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
        });
        this.nav_zoom_slides = new Swiper('.slider-nav', {
            slidesPerView: 3
        });
        this.nav_zoom_slides.on('click', function (swiper) {
            var index = swiper.clickedIndex;
            self.zoom_slides.slideTo(index);
        });
        this.zoom_slides.controller.control = this.nav_zoom_slides;
        this.zoom_slides.on('slidesUpdated', function (swiper) {
            var index = swiper.activeIndex;
            self.nav_zoom_slides.slideTo(index);
        });
    }
    addEventSelectItem(){
        var self = this;
        $('.product-variants .product-list-item').on('click',function(e){
            e.preventDefault();
            var handle = self.handle;
            var optionIndex = $(this).attr('data-option');
            var optionName = $(this).attr('data-name');
            var value = $(this).attr('data-value');
            if(optionIndex == 1){
                var option1 = value;
                self.loadContent('/search?view=custom&q=handle:'+handle+'|option1:'+encodeURIComponent(option1));
            }else if(optionIndex == 2){
                var option1 = $('.product-list-item.is-selected[data-option="1"]').attr('data-value');
                var option2 = value;
                self.loadContent('/search?view=custom&q=handle:'+handle+'|option1:'+encodeURIComponent(option1)+'|option2:'+encodeURIComponent(option2));
            }else{
                var option1 = $('.product-list-item.is-selected[data-option="1"]').attr('data-value');
                var option2 = $('.product-list-item.is-selected[data-option="2"]').attr('data-value');
                var option3 = value;
                self.loadContent('/search?view=custom&q=handle:'+handle+'|option1:'+encodeURIComponent(option1)+'|option2:'+encodeURIComponent(option2)+'|option3:'+encodeURIComponent(option3));
            }
        })
        self.changeTotalPrice();
    }
    loadContent(url){
        var self = this;
        fetch(url)
        .then(res => res.text())
        .then(data => {
            var parser = new DOMParser();
            var htmlDoc = parser.parseFromString(data, 'text/html');
            $('.product-variants').html(htmlDoc.querySelector('.product-configuration').innerHTML);
            $('.product-variants .product-option-list').each((i,list) => {
                var value_selected = $(list).find('.product-list-item.is-selected h3').eq(0).text();
                $('.cart-body .product-option[option-index="'+(i+1)+'"] .option-value').text(value_selected);
            })
            self.addEventSelectItem();
            self.changeTotalPrice();
            self.addEventOpenModal();
        })
    }
    changeTotalPrice(){
        var attrs = ''
        $('.product-variants .product-list-item.is-selected').each((i,ele) => {
            attrs += '[data-option'+(i+1)+'="'+$(ele).attr('data-value')+'"]';
        })
        var option_selected = $('#product-price-list option'+attrs).attr('value');
        var sku = $('#product-price-list option'+attrs).attr('data-sku');
        this.variant_id = option_selected;
        this.variant_sku = sku;
        $('#product-price-list').val(option_selected);
        this.checkOptionIsShowedByCondition();
        this.product_price = parseInt($("#product-price-list option:selected").text());
        var optionsPrice = 0;
        var variant_options = [];
        for(var j = 1;j<=3;j++){
            if(typeof $("#product-price-list option:selected").attr('data-option'+j) != "undefined"){
                variant_options.push($("#product-price-list option:selected").attr('data-option'+j))
            }
        }
        $('.cart-body .product-option .option-price[data-price]').each((i,ele) => {
            var option = $(ele).closest('.product-option').attr('data-option');
            var value = $(ele).closest('.product-option').attr('data-value');
            var price = parseInt($(ele).closest('.product-option').attr('data-price'));
            var qty = 1;
            if(window.autoAdd != undefined){
                window.autoAdd.forEach(x => {
                    if(option == x.option_addon && variant_options.includes(x.option_value)){
                        qty = x.qty;
                    }
                })
            }
            $(ele).closest('.product-option').find('.option-value').text(qty+'x '+value);
            $(ele).closest('.product-option').find('.option-price .money').text('+'+formatMoney(qty*price));
            $(ele).closest('.product-option').attr('data-quantity',qty);
            optionsPrice += parseInt($(ele).attr('data-price')) * qty;
        })
        this.options_price = optionsPrice;
        this.total_price = this.product_price + this.options_price;
        $('.total-price .money').text(formatMoney(this.total_price))
    }
    addEventSelectProperty(){
        var self = this;
        $('.product-options .product-list-item[data-type="property"]').on('click',function(e){
            e.preventDefault();
            var option = $(this).attr('data-header');
            var value = $(this).attr('data-value');
            var isSelected = $(this).hasClass('is-selected');
            $(this).closest('.product-option-list').find('.product-list-item[data-type="option"]').removeClass('is-selected');
            if(!isSelected){
                $('.product-list-item[data-header="'+option+'"]').removeClass('is-selected');
                $(this).addClass('is-selected');
                self.addOption(option,value,"property");
            }else{
                self.removeOption(option);
            }
        })
    }
    addEventSelectOption(){
        var self = this;
        $('.product-options .product-list-item[data-type="option"]').on('click',function(e){
            e.preventDefault();
            var option = $(this).attr('data-header');
            var value = $(this).attr('data-value');
            var variant = $(this).attr('data-variant');
            var price = $(this).attr('data-price');
            var isSelected = $(this).hasClass('is-selected');
            var qty = 1;
            var variant_options = [];
            for(var j = 1;j<=3;j++){
                if(typeof $("#product-price-list option:selected").attr('data-option'+j) != "undefined"){
                    variant_options.push($("#product-price-list option:selected").attr('data-option'+j))
                }
            }
            $(this).closest('.product-option-list').find('.product-list-item[data-type="option"]').removeClass('is-selected');
            if(!isSelected){
                $(this).addClass('is-selected');
                if(window.autoAdd != undefined){
                    window.autoAdd.forEach(x => {
                        if(option == x.option_addon && variant_options.includes(x.option_value)){
                            qty = x.qty;
                            return;
                        }
                    })
                }
                self.addOption(option,value,"option",variant,price,qty);
            }else{
                self.removeOption(option);
            }
            self.changeTotalPrice();
        })
    }
    checkOptionIsShowedByCondition(){
        var variant_options = [];
        for(var j = 1;j<=3;j++){
            if(typeof $("#product-price-list option:selected").attr('data-option'+j) != "undefined"){
                variant_options.push($("#product-price-list option:selected").attr('data-option'+j))
            }
        }
        $('.product-option-list[condition-value]').each((i,ele) => {
            if($(ele).attr('condition-value') != ""){
                var type = $(ele).attr('condition-type');
                var values = $(ele).attr('condition-value').split('###');
                var matched = false;
                values.forEach(value => {
                    var idx = variant_options.findIndex(option =>{
                        return option == value;
                    });
                    if(idx != -1){
                        matched = true;
                    }
                })
                if(matched){
                    if(type == "show"){
                        $(ele).removeAttr('style');
                    }else{
                        $(ele).attr('style','display: none;');
                        var option_name = $(ele).find('.product-list-heading h5').text();
                        $('.product-option[data-option="'+option_name+'"]').remove();
                        $(ele).find('.product-list-item.is-selected').removeClass('is-selected');
                    }
                }else{
                    if(type == "show"){
                        $(ele).attr('style','display: none;');
                    }else{
                        $(ele).removeAttr('style');
                    }
                }
            }
        })
    }
    addOption(option,value,type,variant,price,qty = 1){
        if($('.cart-body .product-option[data-option="'+option+'"]').length){
            $('.cart-body .product-option[data-option="'+option+'"]').find('.option-value').text(type == "property" ? value : qty+'x '+value);
            $('.cart-body .product-option[data-option="'+option+'"]').attr('data-value',value);
            $('.cart-body .product-option[data-option="'+option+'"]').find('.option-price').attr('data-price',price);
            $('.cart-body .product-option[data-option="'+option+'"]').find('.option-price .money').text('+'+formatMoney(price));
        }else{
            if(type == "property"){
                $('.cart-body').append('<div class="product-option" data-option="'+option+'" data-variant="" data-quantity="" data-price="" data-value="'+value+'"><div class="option-name">'+option+'</div><div class="option-detail"><div class="option-value">'+value+'</div></div></div>')
            }else{
                $('.cart-body').append('<div class="product-option" data-option="'+option+'" data-variant="'+variant+'" data-quantity="'+qty+'" data-price="'+(price*qty)+'" data-value="'+value+'"><div class="option-name">'+option+'</div><div class="option-detail"><div class="option-value">'+qty+'x '+value+'</div><div class="option-price" data-price="'+(price*qty)+'"><span class="money">+'+formatMoney(price*qty)+'</span><span class="remove-option"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 48 48"><path d="M24,4C12.954,4,4,12.954,4,24c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20C44,12.954,35.046,4,24,4z M31.561,29.439	c0.586,0.586,0.586,1.535,0,2.121C31.268,31.854,30.884,32,30.5,32s-0.768-0.146-1.061-0.439L24,26.121l-5.439,5.439	C18.268,31.854,17.884,32,17.5,32s-0.768-0.146-1.061-0.439c-0.586-0.586-0.586-1.535,0-2.121L21.879,24l-5.439-5.439	c-0.586-0.586-0.586-1.535,0-2.121s1.535-0.586,2.121,0L24,21.879l5.439-5.439c0.586-0.586,1.535-0.586,2.121,0s0.586,1.535,0,2.121	L26.121,24L31.561,29.439z"></path></svg></span></div></div></div>')
            }
            this.addEventRemoveOption(option);
        }
    }
    removeOption(option){
        $('.product-option[data-option="'+option+'"]').remove();
        $('.product-list-item[data-header="'+option+'"]').removeClass('is-selected');
        this.changeTotalPrice();
    }
    addEventRemoveOption(option){
        var self = this;
        $('.product-option[data-option="'+option+'"] .remove-option').on('click',() => {
            self.removeOption(option);
        })
    }
    addToCart(){
        var self = this;
        $('.add-to-cart-button .atc').on('click',function(){
            var hasError = false;
            $(this).attr('disabled','disabled');
            $('.product-option-list[data-required="true"]').each((i,ele)=>{
                if($(ele).find('.product-list-item.is-selected').length == 0){
                    $(ele).find('.message').removeAttr('style');
                    $(this).removeAttr('disabled');
                    if(!$(ele).is(":hidden")){
                        hasError = true;
                    }
                }else{
                    $(ele).find('.message').attr('style','display: none;');
                }
            })
            if(!hasError){
                var variant_id = self.variant_id;
                var properties = {};
                var items = [];
                $('.product-option[data-option]').each((i,ele) => {
                    properties[$(ele).attr('data-option')] = $(ele).attr('data-value');
                    if($(ele).attr('data-price') > 0){
                        items.push({
                            'id': $(ele).attr('data-variant'),
                            'quantity': $(ele).attr('data-quantity')
                        })
                    }
                })
                items.unshift({
                    'id': variant_id,
                    'quantity': 1,
                    'properties': properties
                });
                let formData = {
                    'items': items
                };
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    window.location.href = window.Shopify.routes.root + 'cart'
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            }else{
              alert('Please select all the required items');
            }
        })
    }
    addEventOpenModal(isReopen){
        var self = this;
        $('.zoom-image').on('click',function(){
            self.openModal($(this).attr('data-url'));
        })
    }
    addEventCloseModal(){
        var self = this;
        $('.close-modal').on('click',function(){
            self.closeModal();
        })
    }
    openModal(url){
        console.log(url)
        $('#myModal').show();
        $('body').addClass('overflow-hidden');
        $('#MainHeader').hide();
        var index = $('.slider-for .zoom-image[data-url="'+url+'"]').attr('data-index');
        this.zoom_slides.slideTo(index);
        setTimeout(() => {
            this.nav_zoom_slides.slideTo(index);
        },50)
    }
    closeModal(){
        $('#myModal').hide();
        $('#MainHeader').show();
        $('body').removeClass('overflow-hidden');
    }
}
const money_format = "${{amount}}";
formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$.fn.isOnScreen = function(){

    var win = $(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    console.log(bounds.top)

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

};
$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};